export default {
  title: 'Betalingsoplysninger verificeret',
  description: 'Dine betalingsoplysninger er blevet verificeret.',
};
